import React from 'react'
import { withTranslation } from 'react-i18next'
import OutsideClickHandler from 'react-outside-click-handler'
import { isEqual } from 'lodash'
import EditorMain from './Editor.js'

import Toast from '../../common/components/Toast/Toast'

import { IconClose } from '../../svg'

class IntegrationsTab extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            saving_process: false,

            action_item: {
                is_open: false,
                index: null,
                id: null,
                is_checked: false,
                settings: null,
            },

            list: [
                {
                    id: 'ga',
                    name: props.t('_components._editor._tabs._integrations._items._google_analytics.title'),
                    description: props.t(
                        '_components._editor._tabs._integrations._items._google_analytics.description',
                    ),
                    image: require(`../../images/png/integrations/ga.png`),
                    is_checked: false,
                    is_disabled: false,
                    settings: {
                        tracking_id: '',
                    },
                },
                {
                    id: 'fb_p',
                    name: props.t('_components._editor._tabs._integrations._items._facebook_pixel.title'),
                    description: props.t('_components._editor._tabs._integrations._items._facebook_pixel.description'),
                    image: require(`../../images/png/integrations/fb_pixel.png`),
                    is_checked: false,
                    is_disabled: false,
                    settings: {
                        tracking_id: '',
                    },
                },
                {
                    id: 'email',
                    name: props.t('_components._editor._tabs._integrations._items._email.title'),
                    description: props.t('_components._editor._tabs._integrations._items._email.description'),
                    image: require(`../../images/png/integrations/mail.png`),
                    is_checked: false,
                    is_disabled: true,
                },
                {
                    id: 'hs',
                    name: props.t('_components._editor._tabs._integrations._items._hubspot.title'),
                    description: props.t('_components._editor._tabs._integrations._items._hubspot.description'),
                    image: require(`../../images/png/integrations/hs.png`),
                    is_checked: false,
                    is_disabled: true,
                },
                {
                    id: 'sf',
                    name: props.t('_components._editor._tabs._integrations._items._salesforce.title'),
                    description: props.t('_components._editor._tabs._integrations._items._salesforce.description'),
                    image: require(`../../images/png/integrations/sf.png`),
                    is_checked: false,
                    is_disabled: true,
                },
                {
                    id: 'mt',
                    name: props.t('_components._editor._tabs._integrations._items._marketo.title'),
                    description: props.t('_components._editor._tabs._integrations._items._marketo.description'),
                    image: require(`../../images/png/integrations/marketo.png`),
                    is_checked: false,
                    is_disabled: true,
                },
            ],
        }
        this.base_state = this.state
    }

    async componentDidMount() {
        this._isMounted = true

        let { list } = this.state

        const project_serialized = await EditorMain.serializeProject()

        // Google Analytics | index = 0
        if (project_serialized.app && project_serialized.app.google) {
            list[0].is_checked = project_serialized.app.google.trackingId.length
            list[0].settings.tracking_id = project_serialized.app.google.trackingId
        }
        // Facebook Pixel | index = 1
        if (project_serialized.app && project_serialized.app.facebook) {
            list[1].is_checked = project_serialized.app.facebook.trackingId.length
            list[1].settings.tracking_id = project_serialized.app.facebook.trackingId
        }

        this.setState({
            list,
        })
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    handleClick__card = (index, disabled) => () => {
        if (!disabled) {
            const { list } = this.state

            let format_settings = {}

            for (let [key, value] of Object.entries(list[index].settings)) {
                format_settings[key] = {
                    value,
                    _error: '',
                }
            }

            this.setState(prevState => ({
                action_item: {
                    ...prevState.action_item,
                    is_open: true,
                    index,
                    id: list[index].id,
                    is_checked: list[index].is_checked,
                    settings: format_settings,
                },
            }))
        }
    }

    handleChange__settings_input = target => async evt => {
        evt.persist()
        try {
            this.setState(prevState => ({
                action_item: {
                    ...prevState.action_item,
                    settings: {
                        ...prevState.action_item.settings,
                        [target]: {
                            ...prevState.action_item.settings[target],
                            value: evt.target.value,
                            _error: '',
                        },
                    },
                },
            }))
        } catch (err) {
            console.error(err)
        }
    }

    save = async evt => {
        evt.preventDefault()

        try {
            const { events } = this.props
            const { action_item } = this.state

            const value = action_item.settings.tracking_id.value

            this.setState({
                saving_process: true,
            })

            switch (action_item.id) {
                case 'ga': {
                    if (this.isAnalyticsCode(value)) {
                        EditorMain.setEditedAppData('app.google.trackingId', value)

                        let { list } = this.state

                        list[0].is_checked = true
                        list[0].settings.tracking_id = value

                        this.setState(prevState => ({
                            action_item: {
                                ...prevState.action_item,
                                is_checked: true,
                            },
                            list,
                        }))

                        // await EditorMain.saveProject();

                        await events.init_save_silent()
                        this.close_settings()
                    } else {
                        this.setState(prevState => ({
                            action_item: {
                                ...prevState.action_item,
                                settings: {
                                    ...prevState.action_item.settings,
                                    tracking_id: {
                                        ...prevState.action_item.settings.tracking_id,
                                        _error: 'Invalid format',
                                    },
                                },
                            },
                        }))
                    }
                    break
                }
                case 'fb_p': {
                    if (Number.isFinite(parseFloat(value))) {
                        EditorMain.setEditedAppData('app.facebook.trackingId', value)

                        let { list } = this.state

                        list[1].is_checked = true
                        list[1].settings.tracking_id = value

                        this.setState(prevState => ({
                            action_item: {
                                ...prevState.action_item,
                                is_checked: true,
                            },
                            list,
                        }))

                        // await EditorMain.saveProject();
                        await events.init_save_silent()
                        this.close_settings()
                    } else {
                        this.setState(prevState => ({
                            action_item: {
                                ...prevState.action_item,
                                settings: {
                                    ...prevState.action_item.settings,
                                    tracking_id: {
                                        ...prevState.action_item.settings.tracking_id,
                                        _error: 'Invalid format',
                                    },
                                },
                            },
                        }))
                    }
                    break
                }
                default:
                    break
            }
        } catch (err) {
            console.error(err)
            Toast('error', {})
        } finally {
            this.setState({
                saving_process: false,
            })
        }
    }

    disable = async evt => {
        evt.preventDefault()

        try {
            const { events } = this.props
            const { action_item } = this.state

            this.setState({
                saving_process: true,
            })

            switch (action_item.id) {
                case 'ga': {
                    EditorMain.setEditedAppData('app.google.trackingId', '')

                    let { list } = this.state

                    list[0].is_checked = false
                    list[0].settings.tracking_id = ''

                    this.setState(prevState => ({
                        action_item: {
                            ...prevState.action_item,
                            is_checked: false,
                            settings: {
                                ...prevState.action_item.settings,
                                tracking_id: {
                                    ...prevState.action_item.settings.tracking_id,
                                    value: '',
                                },
                            },
                        },
                        list,
                    }))

                    // await EditorMain.saveProject();
                    await events.init_save_silent()
                    this.close_settings()
                    break
                }
                case 'fb_p': {
                    EditorMain.setEditedAppData('app.facebook.trackingId', '')

                    let { list } = this.state

                    list[1].is_checked = false
                    list[1].settings.tracking_id = ''

                    this.setState(prevState => ({
                        action_item: {
                            ...prevState.action_item,
                            is_checked: false,
                            settings: {
                                ...prevState.action_item.settings,
                                tracking_id: {
                                    ...prevState.action_item.settings.tracking_id,
                                    value: '',
                                },
                            },
                        },
                        list,
                    }))

                    // await EditorMain.saveProject();
                    await events.init_save_silent()
                    this.close_settings()
                    break
                }
                default:
                    break
            }
        } catch (err) {
            console.error(err)
            Toast('error', {})
        } finally {
            this.setState({
                saving_process: false,
            })
        }
    }

    close_settings = () => {
        this.setState({
            action_item: {
                ...this.base_state.action_item,
                is_open: false,
            },
        })
    }

    isAnalyticsCode(str) {
        return /^ua-\d{4,9}-\d{1,4}$/i.test(str.toString())
    }

    render() {
        const { events, t } = this.props
        const { list, action_item, saving_process } = this.state

        const watcher__disabled = id => {
            switch (id) {
                case 'ga': {
                    return (
                        !action_item.settings.tracking_id.value.length ||
                        isEqual(
                            {
                                tracking_id: action_item.settings.tracking_id.value,
                            },
                            {
                                tracking_id: list[action_item.index].settings.tracking_id,
                            },
                        ) ||
                        saving_process
                    )
                }
                case 'fb_p': {
                    return (
                        !action_item.settings.tracking_id.value.length ||
                        isEqual(
                            {
                                tracking_id: action_item.settings.tracking_id.value,
                            },
                            {
                                tracking_id: list[action_item.index].settings.tracking_id,
                            },
                        ) ||
                        saving_process
                    )
                }
                default:
                    return false
            }
        }

        return (
            <div className="editor-tab--integrations">
                <h1>
                    {t('_components._editor._tabs._integrations.title_1_1')}{' '}
                    <span onClick={events.change_step(3)}>
                        {t('_components._editor._tabs._integrations.title_1_2')}
                    </span>{' '}
                    {t('_components._editor._tabs._integrations.title_1_3')}
                </h1>

                <div className="integrations-wrap">
                    <ul className="cards">
                        {list.map((item, index) => {
                            return (
                                <li
                                    key={index}
                                    className={`cards-item${item.is_checked ? ' is-checked' : ''}${
                                        item.is_disabled ? ' is-disabled' : ''
                                    }`}
                                    onClick={this.handleClick__card(index, item.is_disabled)}
                                >
                                    <div className="switcher"></div>
                                    <div className="image">
                                        <img src={item.image} alt="" />
                                    </div>
                                    {item.is_disabled ? (
                                        <div className="coming-soon">{t('_common.coming_soon')}</div>
                                    ) : (
                                        <p>{item.description}</p>
                                    )}
                                </li>
                            )
                        })}
                    </ul>
                </div>

                <div className={`settings-window${action_item.is_open ? ' is-active' : ''}`}>
                    <OutsideClickHandler onOutsideClick={this.close_settings}>
                        <div className="content">
                            <div className="close-btn" onClick={this.close_settings}>
                                <IconClose />
                            </div>
                            {action_item.id === 'ga' ? (
                                <>
                                    <div className="content__title">
                                        {t('_components._editor._tabs._integrations._items._google_analytics.title')}
                                    </div>

                                    <div
                                        className={`input-box ${
                                            action_item.settings.tracking_id._error.length ? 'is-error' : ''
                                        }`}
                                    >
                                        <div className="title">
                                            {t(
                                                '_components._editor._tabs._integrations._items._google_analytics.input_title',
                                            )}
                                        </div>
                                        <input
                                            autoComplete="off"
                                            type="text"
                                            value={action_item.settings.tracking_id.value}
                                            placeholder="UA-111111111-1"
                                            onChange={this.handleChange__settings_input('tracking_id')}
                                        />
                                        <p className="msg msg--error">{action_item.settings.tracking_id._error}</p>
                                    </div>

                                    <div className="content__sub-title">
                                        {t(
                                            '_components._editor._tabs._integrations._items._google_analytics.manual_title',
                                        )}
                                    </div>
                                    <ul>
                                        <li>
                                            1.{' '}
                                            {t(
                                                '_components._editor._tabs._integrations._items._google_analytics._manual._1.text_1',
                                            )}{' '}
                                            <a
                                                href="https://analytics.google.com/analytics/web/provision/#/provision"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {t(
                                                    '_components._editor._tabs._integrations._items._google_analytics._manual._1.text_2',
                                                )}
                                            </a>
                                        </li>
                                        <li>
                                            2.{' '}
                                            {t(
                                                '_components._editor._tabs._integrations._items._google_analytics._manual._2.text_1',
                                            )}
                                        </li>
                                        <li>
                                            3.{' '}
                                            {t(
                                                '_components._editor._tabs._integrations._items._google_analytics._manual._3.text_1',
                                            )}
                                        </li>
                                        <li>
                                            4.{' '}
                                            {t(
                                                '_components._editor._tabs._integrations._items._google_analytics._manual._4.text_1',
                                            )}
                                        </li>
                                    </ul>

                                    <div className="btns">
                                        <button
                                            className="button"
                                            data-size="md"
                                            disabled={watcher__disabled('ga')}
                                            onClick={this.save}
                                            data-variant="primary"
                                        >
                                            {t('_common.save')}
                                        </button>
                                        {action_item.is_checked ? (
                                            <button
                                                className="button"
                                                data-size="md"
                                                disabled={saving_process}
                                                data-variant="primary-danger"
                                                onClick={this.disable}
                                            >
                                                {t('_common.disable')}
                                            </button>
                                        ) : null}
                                    </div>
                                </>
                            ) : null}
                            {action_item.id === 'fb_p' ? (
                                <>
                                    <div className="content__title">
                                        {t('_components._editor._tabs._integrations._items._facebook_pixel.title')}
                                    </div>

                                    <div
                                        className={`input-box ${
                                            action_item.settings.tracking_id._error.length ? 'is-error' : ''
                                        }`}
                                    >
                                        <div className="title">
                                            {t(
                                                '_components._editor._tabs._integrations._items._facebook_pixel.input_title',
                                            )}
                                        </div>
                                        <input
                                            autoComplete="off"
                                            type="text"
                                            value={action_item.settings.tracking_id.value}
                                            placeholder="1111111111111111"
                                            onChange={this.handleChange__settings_input('tracking_id')}
                                        />
                                        <p className="msg msg--error">{action_item.settings.tracking_id._error}</p>
                                    </div>

                                    <div className="content__sub-title">
                                        {t(
                                            '_components._editor._tabs._integrations._items._facebook_pixel.manual_title',
                                        )}
                                    </div>
                                    <ul>
                                        <li>
                                            1.{' '}
                                            {t(
                                                '_components._editor._tabs._integrations._items._facebook_pixel._manual._1.text_1',
                                            )}
                                        </li>
                                        <li>
                                            2.{' '}
                                            {t(
                                                '_components._editor._tabs._integrations._items._facebook_pixel._manual._2.text_1',
                                            )}{' '}
                                            <a
                                                href="https://www.facebook.com/business/learn/facebook-ads-pixel"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {t(
                                                    '_components._editor._tabs._integrations._items._facebook_pixel._manual._2.text_2',
                                                )}
                                            </a>{' '}
                                            {t(
                                                '_components._editor._tabs._integrations._items._facebook_pixel._manual._2.text_3',
                                            )}
                                        </li>
                                    </ul>

                                    <div className="btns">
                                        <button
                                            className="button"
                                            data-size="md"
                                            disabled={watcher__disabled('fb_p')}
                                            onClick={this.save}
                                            data-variant="primary"
                                        >
                                            {t('_common.save')}
                                        </button>
                                        {action_item.is_checked && !saving_process ? (
                                            <button
                                                className="button"
                                                data-size="md"
                                                disabled={saving_process}
                                                data-variant="primary-danger"
                                                onClick={this.disable}
                                            >
                                                {t('_common.disable')}
                                            </button>
                                        ) : null}
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </OutsideClickHandler>
                </div>
            </div>
        )
    }
}

export default withTranslation('translations')(IntegrationsTab)
